import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const stockAvailabilityList = createAsyncThunk('stockAvailabilityList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `stock_availability`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'department_id': data?.department_id,
                'location_id': data?.location_id,
                'component_id': data?.component_id,
                'equipment_id': data?.equipment_id,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const stockAvailabilityListSlice = createSlice({
    name: 'stockAvailabilityList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(stockAvailabilityList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(stockAvailabilityList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default stockAvailabilityListSlice.reducer;